import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: 'input'
})
export class NumericInputDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const nativeElement = this.el.nativeElement;
    if (nativeElement.type !== 'number' && nativeElement.inputMode !== 'numeric') return;

    // Prevent 'e', 'E', '+', and '-' in numeric inputs
    if (['e', 'E', '+', '-'].includes(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const nativeElement = this.el.nativeElement;
    if (nativeElement.type !== 'number' && nativeElement.inputMode !== 'numeric') return;

    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text');
    if (pastedText && (pastedText.includes('e') || pastedText.includes('E') || pastedText.includes('+') || pastedText.includes('-'))) {
      event.preventDefault();
    }
  }
}
